import { createSelector } from 'reselect';

export const initialState = {};

const loadingSelector = (state) => state.loading || initialState;

export const makeSelectIsLoading = (loader) => createSelector(loadingSelector, (state) => !!state[loader]);
